/* eslint-disable */

export default {
  name: "BolideLoader"
};
